import { render, staticRenderFns } from "./ButtonUploadComponent.vue?vue&type=template&id=5c3c124c&lang=pug"
import script from "./ButtonUploadComponent.vue?vue&type=script&lang=js"
export * from "./ButtonUploadComponent.vue?vue&type=script&lang=js"
import style0 from "./ButtonUploadComponent.vue?vue&type=style&index=0&id=5c3c124c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports